/**
 * Classe che gestisce tramite attributi del form il captcha in pagina, tra turnstile e google recaptcha
 */
import { FallcoConsole } from "fallco-frontend-framework/src/js/libs/fallco_console.js";
import { FallcoClass } from "fallco-frontend-framework/src/js/classes/FallcoClass.js";
import browserDetector from "fallco-frontend-framework/src/js/libs/utilities/src/BrowserDetector.js";

class CaptchaClient extends FallcoClass {
  constructor() {
    super("CaptchaClient");

    this.captcha_keys = []
    this.formsList = null
    this.instances = {}
    this.nonce = null

    document.addEventListener('DOMContentLoaded', () => {
      this._init()
    });

    $(document).on("shown.modal.helper", (e, modalIstance) => {
      this._init(modalIstance.$modal[0])
    });

    $(document).on("hide.modal.helper", (e, modalIstance) => {
      debugger
    });

    return super.expose_to_public("CaptchaClient", this);
  }

  /**
   * Funzione di inizializzazione
   * @param {HTMLElement} [container=document] Elemento HTML in cui cercare il form (es. modale) altrimenti cerca nel document
   * @private
   */
  _init(container = document) {
    this.captcha_keys = window.captcha_keys || []
    this.nonce = document.querySelector('script[nonce]')?.nonce || document.querySelector('script[nonce]')?.getAttribute('nonce') || null
    this.formsList = container.querySelectorAll("form[fw-captcha-enabled='1'][name][fw-captcha-type][fw-captcha-vendor][fw-captcha-version]");

    if (this.formsList.length > 0 && this.captcha_keys.length > 0) {
      this.formsList.forEach(form => {
        this.instances[form.name] = new CaptchaClientInstance(form, this.captcha_keys, this.nonce)
      })
    }
  }
}

new CaptchaClient();

class CaptchaClientInstance extends FallcoClass {
  constructor(targetForm, captchaKeys, nonce) {
    super("CaptchaClient");

    this.form = null
    this.captcha_type = null
    this.captcha_vendor = null
    this.captcha_version = null
    this.captcha_front_key = null
    this.captcha_name = null

    this.captcha_keys = null
    this.captcha_key = null

    this.captcha_submit_element = null
    this.captcha_fn_submit = null

    this.turnstileInstanceId = null
    this.intervalTurnstileWidget = null

    this.nonce = null

    this._init(targetForm, captchaKeys, nonce)
  }

  /**
   * Funzione di inizializzazione che chiama i metodi in base al tipo di recaptcha da caricare
   * @param {HTMLFormElement} [targetForm = this.form] Form per cui gestire il captcha
   * @param {Object} [captchaKeys = this.captcha_keys] Oggetto con tutte le chiavi per questo dominio
   * @param nonce
   * @private
   */
  _init(targetForm = this.form, captchaKeys = this.captcha_keys, nonce = this.nonce) {
    if (!$.helper.loading_frame.counter) {
      $.helper.loading_frame.show();
    }

    this.form = targetForm
    this.captcha_keys = captchaKeys
    this.nonce = nonce

    // Aggiungere controllo per Safari
    this.forceGoogleRecaptcha = browserDetector.detectSafari() && this.captcha_vendor !== 'google';
    if (!this.forceGoogleRecaptcha) {

      this.captcha_type = this.form.getAttribute('fw-captcha-type')
      this.captcha_vendor = this.form.getAttribute('fw-captcha-vendor')
      this.captcha_version = this.form.getAttribute('fw-captcha-version')

      this.captcha_key = this.captcha_keys.find(key => key.vendor === this.captcha_vendor && key.type === this.captcha_type && key.version.toString() === this.captcha_version)

      this.captcha_front_key = this.captcha_key?.front_key

      if (!this.captcha_front_key) {
        console.error('Attenzione, non è presente la front-key');
        return;
      }

      this.captcha_name = this.captcha_key.name

      this.captcha_submit_element = this.form.getAttribute("fw-captcha-submit-element") || null
      this.captcha_fn_submit = this.form.getAttribute("fw-captcha-fn-submit") || null

      this.forceGoogleRecaptcha = false;

      this._createInputHidden();

        if (
          this.captcha_vendor === "cloudflare" &&
          this.captcha_type === "turnstile" &&
          this.captcha_version === '3'
        ) {
          // Turnstile
          this._createWidgetTurnstile();
          if (document.getElementById('turnstileScript')) {
            this._loadTurnstile();
          } else {
            this._createScriptTurnstile();
          }
          this._intervalResetTurnStileWidget();
        } else if (
          this.captcha_vendor === "google" &&
          this.captcha_type === "recaptcha" &&
          this.captcha_version === '3'
        ) {
          // Google Recaptcha
          this._createInputGRecaptchaResponse();
          this._createScriptGoogleRecaptcha();
          this._addEventToSubmitBtn();
          $.helper.loading_frame.hide()
        }

    } else{

      this.captcha_type = 'recaptcha';
      this.captcha_vendor = 'google';
      this.captcha_version = '3';

      this.captcha_key = this.captcha_keys.find(key => key.vendor === this.captcha_vendor && key.type === this.captcha_type && key.version.toString() === this.captcha_version)

      this.captcha_front_key = this.captcha_key?.front_key

      if (!this.captcha_front_key) {
        console.error('Attenzione, non è presente la front-key');
        return;
      }

      this.captcha_name = this.captcha_key.name

      this.captcha_submit_element = this.form.getAttribute("fw-captcha-submit-element") || null
      this.captcha_fn_submit = this.form.getAttribute("fw-captcha-fn-submit") || null

      this._createInputHidden();
      // Google Recaptcha
      this._createInputGRecaptchaResponse();
      this._createScriptGoogleRecaptcha();
      this._addEventToSubmitBtn();
      $.helper.loading_frame.hide()
    }
  }

  /**
   * Aggiunge un input hidden captcha_name al form
   * @private
   */
  _createInputHidden() {
    if (this.form.elements.captcha_name) {
      this.form.elements.captcha_name.value = this.captcha_name
    } else {
      let inputHidden = document.createElement("input");
      inputHidden.setAttribute("type", "hidden");
      inputHidden.name = 'captcha_name';
      inputHidden.setAttribute("fh_track", "false");
      inputHidden.value = this.captcha_name;
      this.form.appendChild(inputHidden);
    }
  }

  /**
   * Crea l'elemento div in pagina necessario per Turnstile e lo appende al form
   * @private
   */
  _createWidgetTurnstile() {
    let widgetTurnstile = document.createElement("div");
    widgetTurnstile.id = `turnstileWidget-${this.form.name}`;
    widgetTurnstile.style.height = this.captcha_type === "turnstile_managed" ? "65px" : "0";
    this.form.appendChild(widgetTurnstile);
  }

  /**
   * Crea lo script di turnstile da appendere all'head della pagina e all'onload  chiama la funzione con tutti i controlli
   * @private
   */
  _createScriptTurnstile() {
    window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Creazione script turnstile', 'info')
    let turnstileScript = document.createElement("script");

    turnstileScript.setAttribute("src", "https://challenges.cloudflare.com/turnstile/v0/api.js");
    turnstileScript.setAttribute("async", "async");
    turnstileScript.setAttribute("defer", "defer");
    turnstileScript.setAttribute("nonce", this.nonce);
    turnstileScript.id = 'turnstileScript'

    document.head.appendChild(turnstileScript);

    turnstileScript.onload = () => {
      this._loadTurnstile();
    };
  }

  /**
   * Funzione che  avvia l'istanza del widget di turnstile e aggiunge controlli
   * @private
   */
  _loadTurnstile() {

    if (!window.turnstile) {
      window.setTimeout(() => this._loadTurnstile(), 100);
      return;
    }
    console.debug("Fallco: Rendering Turnstile Widget");

    const turnstileInstanceData = {
      sitekey: this.captcha_front_key,
      theme: "light",
      action: this.form.name,
      language: "it",
      retry: "auto",
      "retry-interval": 1000,
      "response-field-name": "g-recaptcha-response",
      callback: () => {
        console.debug(`Fallco: Turnstile Challenge Success (${this.form.name})`);
        window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Challenge completata, render completato', 'debug')
        $.helper.loading_frame.hide();
        super.trigger_custom_event({
          name:   'ready',
          target: this.form,
          data:   {
            captcha_type : this.captcha_type,
            captcha_vendor: this.captcha_vendor,
            captcha_version: this.captcha_version,
            captcha_name: this.captcha_name
          }
        });
      },
      "expired-callback": () => {
        console.debug(`Fallco: Turnstile Challenge Expired (${this.form.name})`);
        window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Challenge expired', 'error')
        this._resetTurnstile()
      },
      "timeout-callback": () => {
        console.debug(`Fallco: Turnstile Challenge Timeout (${this.form.name})`);
        window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Challenge timeout', 'error')
        this._resetTurnstile()
      },
      "error-callback": (resp) => {
        console.debug(`Fallco: Turnstile Challenge Error (${this.form.name}): ${resp}`);
        window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Challenge error', 'error', {name: this.form.name, resp})
        if (resp === "200100" || resp.includes("300") || resp === 'crashed') {
          this._fallbackTurnstileToRecaptcha()
          window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Fallback a Google Recaptcha', 'debug')
        } else {
          this._resetTurnstile()
        }
      },
      "unsupported-callback": () => {
        console.debug(`Fallco: Turnstile Unsupported Browser (${this.form.name})`);
        window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Browser non supportato', 'debug', {name: this.form.name})
        $.helper.loading_frame.hide();
        alert("Il browser utilizzato non è più supportato per questioni di sicurezza, si prega di aggiornarlo oppure di cambiare browser.");
      }
    }

    window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Rendering turnstile...', 'debug', {
      window_turnstile: window.turnstile,
      turnstileInstanceData,
    })
    try{
      this.turnstileInstanceId = window.turnstile.render(`#turnstileWidget-${this.form.name}`, turnstileInstanceData);
    } catch (e) {
      console.error("Errore nell'avviare Turnstile.render:", e);
      window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Errore nell\'avviare Turnstile.render:', 'error', {e})
    }

  }

  /**
   * Funzione che rinuove il widget di Turnstile
   * @private
   */
  _removeTurnstile() {
    window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Preparazione a rimuovere turnstile', 'debug', {turnstileId: this.turnstileInstanceId})
    if (this.turnstileInstanceId) {
      window.turnstile?.remove(this.turnstileInstanceId)
      this.turnstileInstanceId = null
      clearInterval(this.intervalTurnstileWidget)
      document.getElementById(`turnstileWidget-${this.form.name}`).remove()
      //document.getElementById(`turnstileScript`).remove()
      this.form.elements.captcha_name.value = ''
      window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Turnstile rimosso', 'debug')
    }
  }

  /**
   * Funzione che resetta il widget di Turnstile
   * @private
   */
  _resetTurnstile() {
    if (this.turnstileInstanceId) {
      if (!$.helper.loading_frame.counter) {
        $.helper.loading_frame.show();
      }
      window.turnstile?.reset(this.turnstileInstanceId);
      window.fallco?.sentryHelper?.addSentryBreadcrumb('Turnstile', 'Turnstile resettato', 'debug')
    }
  }


  /**
   * Funzione pubblica che resetta il widget di Turnstile
   * @public
   */
  resetTurnstile() {
    this._resetTurnstile()
  }

  /**
   * Funzione di reset del widget di turnstile per aggiornare la challenge ogni 90 secondi
   * @private
   */
  _intervalResetTurnStileWidget() {
    // reset widget every 90 seconds
    this.intervalTurnstileWidget = setInterval(() => {
      this._resetTurnstile()
    }, 90000);
  }


  /**
   * Input hidden g-recaptcha-response che viene valorizzato prima del submit del form
   * @private
   */
  _createInputGRecaptchaResponse() {
    let inputHiddenGRecaptcha = document.createElement("input");
    inputHiddenGRecaptcha.setAttribute("type", "hidden");
    inputHiddenGRecaptcha.setAttribute("name", "g-recaptcha-response");
    inputHiddenGRecaptcha.setAttribute("fh_track", "false");
    inputHiddenGRecaptcha.setAttribute("value", "");
    this.form.appendChild(inputHiddenGRecaptcha);
  }

  /**
   * Funzione che crea lo script per google recaptcha e lo appende all'head
   * @private
   */
  _createScriptGoogleRecaptcha() {
    window.fallco?.sentryHelper?.addSentryBreadcrumb('Google recaptcha', 'Creazione dello script Google', 'debug')
    let googleScript = document.createElement("script");
    googleScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=" + this.captcha_front_key);
    googleScript.setAttribute("async", "async");
    googleScript.setAttribute("defer", "defer");
    googleScript.setAttribute("nonce", this.nonce);
    googleScript.id = 'googleScript'

    document.head.appendChild(googleScript);

    googleScript.onload = () => {
      super.trigger_custom_event({
        name:   'ready',
        target: this.form,
        data:   {
          captcha_type : this.captcha_type,
          captcha_vendor: this.captcha_vendor,
          captcha_version: this.captcha_version,
          captcha_name: this.captcha_name
        }
      });
    };
  }

  /**
   * Trova l'elemento di submit del form e resta in ascolto al click ed aggiunge il g-recaptcha-response
   * @private
   */
  _addEventToSubmitBtn() {
    let elSubmit;
    if(this.captcha_submit_element) {
      elSubmit = this.form.getElementById(this.captcha_submit_element);
      elSubmit.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.challengeGrecaptcha()) {
          window[this.captcha_fn_submit]()
        }
      });
    }
  }

  /**
   * Funzione fallback da Turnstile a Recaptcha in caso di particolari errori
   */
  _fallbackTurnstileToRecaptcha() {
    this._removeTurnstile()
    this.form.setAttribute('fw-captcha-vendor', 'google')
    this.form.setAttribute('fw-captcha-type', 'recaptcha')
    this.form.setAttribute('fw-captcha-version', '3')
    $.helper.loading_frame.hide();

    this._init()
  }

  async challengeGrecaptcha() {

    return new Promise((resolve) => {
        if (
          window.grecaptcha &&
          this.captcha_vendor === "google" &&
          this.captcha_type === "recaptcha" &&
          this.captcha_version === '3'
        ) {
        window.grecaptcha.ready(
          async () => {
              const token = await window.grecaptcha.execute(
                this.captcha_front_key,
                { action: this.form.name },
              );
              this.form.elements["g-recaptcha-response"].value = token;

              resolve(!!token);
            })
        } else {
          console.debug(`Fallco: reCaptcha Challenge Failed (${this.form.name})`);
          resolve(false)
        }
      });

  }

  getCaptchaType() {
    if (
      window.grecaptcha &&
      this.captcha_vendor === "google" &&
      this.captcha_type === "recaptcha" &&
      this.captcha_version === '3'
    ) {
      return 'recaptcha';
    } else if (
      this.captcha_vendor === "cloudflare" &&
      this.captcha_type === "turnstile" &&
      this.captcha_version === '3'
    ) {
      return 'turnstile';
    }
  }
}

export { CaptchaClientInstance };